type AppConfig = {
  API_BASE_URL?: string;
  COPILOTKIT_ENABLED?: boolean | string;
  COPILOTKIT_RUNTIME_URL?: string;
  WEB_BASE_URL?: string;
  SENTRY_DSN?: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

const appConfig =
  typeof window === 'undefined' ? undefined : window.__APP_CONFIG__;

export const API_BASE_URL =
  appConfig?.API_BASE_URL ??
  import.meta.env.VITE_API_BASE_URL ??
  'http://localhost:3000';

export const COPILOTKIT_RUNTIME_URL =
  appConfig?.COPILOTKIT_RUNTIME_URL ??
  import.meta.env.VITE_COPILOTKIT_RUNTIME_URL ??
  `${API_BASE_URL}/api/v1/copilotkit`;

export const COPILOTKIT_ENABLED =
  toBoolean(
    appConfig?.COPILOTKIT_ENABLED ?? import.meta.env.VITE_COPILOTKIT_ENABLED,
  ) ?? false;

export const WEB_BASE_URL =
  appConfig?.WEB_BASE_URL ??
  import.meta.env.VITE_WEB_BASE_URL ??
  'http://localhost:5173';

export const SENTRY_DSN =
  appConfig?.SENTRY_DSN ??
  import.meta.env.VITE_SENTRY_DSN ??
  'http://sentry-dsn';

export const SENTRY_ENVIRONMENT =
  import.meta.env.VITE_SENTRY_ENVIRONMENT ?? import.meta.env.MODE;

export const SENTRY_RELEASE = import.meta.env.VITE_SENTRY_RELEASE;

export const FIELD_NATION_BASE_URL =
  import.meta.env.VITE_FIELD_NATION_BASE_URL ?? 'https://app.fieldnation.com';

export const WEB_APP_VERSION =
  import.meta.env.VITE_APP_VERSION?.trim() || '0.0.0';
export const WEB_GIT_BRANCH =
  import.meta.env.VITE_GIT_BRANCH?.trim() || 'local';
export const WEB_GIT_COMMIT_SHORT = (
  import.meta.env.VITE_GIT_COMMIT_SHORT?.trim() || 'unknown'
).slice(0, 7);

function toBoolean(value: boolean | string | undefined): boolean | undefined {
  if (typeof value === 'boolean') return value;
  if (typeof value !== 'string') return undefined;
  if (['1', 'true', 'yes', 'on'].includes(value.toLowerCase())) return true;
  if (['0', 'false', 'no', 'off'].includes(value.toLowerCase())) return false;
  return undefined;
}
